import { createAction } from 'redux-actions';
import {GET_DATA_IMPORTS,GET_DATA_IMPORT_CODE,GET_CLEAN_DATA_IMPORT_CODE} from '../constants/get';
export const setDataImports = createAction(GET_DATA_IMPORTS, (u) => u);
export const setDataImportsCode = createAction(GET_DATA_IMPORT_CODE, (u) => u);
export const setCleanDataImportsCode = createAction (GET_CLEAN_DATA_IMPORT_CODE, (u) => u);
